export default __webpack_public_path__ + "abc923864cb19e1111246f8a987618f7.png";